// Module
var code = `<table class="table no-print history" ng-table="\$ctrl.tableConfig">
  <thead>
  <tr>
    <th>No</th>
    <th>Date and time</th>
    <th>Type</th>
    <th>Status</th>
    <th>Amount</th>
  </tr>
  </thead>
  <tbody>
  <tr ng-repeat-start="item in \$data"
      class="table__row--clickable"
      ng-click="\$ctrl.rowClicked(item, \$event)"
      ng-class="{'selected': \$ctrl.selectedEntryId === item.id}"
  >
    <td>{{\$index+1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}} </td>
    <td>{{item.systemTime | prettyDateTime }}
      <span class="label label-info" ng-if="item.systemInitiated">EOD</span>
    </td>
    <td>{{item.entryType === 'APPLY_FEE_CUSTOM' && item.attributes.CUSTOM_FEE_NAME ?
      item.attributes.CUSTOM_FEE_NAME : (item.entryType | translate:'PRODUCT_HISTORY')}}
      <span class="label status--danger" ng-if="item.entryGroup === 'REVERT'"> Revert</span></td>
    <td class="status-{{item.status | uppercase}}">{{item.status | prettyEnum}}</td>
    <td>{{item.amount | nxCurrency:'dashOnZero'}}</td>
  </tr>
  <tr ng-repeat-end class="table__row--not-hoverable">
    <td colspan="100%">
      <div class="toggleable-panel-wrapper"
           ng-class="{'toggleable-panel-wrapper--toggled': \$ctrl.selectedEntryId === item.id}">
        <inline-panel on-hide="\$ctrl.onInlinePannelHidden()">
          <div class="inline-panel__container"
               ng-repeat="attr in item.details">
            <label class="inline-panel__label">{{attr.name | prettyEnum}}:</label>
            <p class="inline-panel__value">{{attr.value}}</p>
          </div>
          <div class="transclude" ng-transclude></div>
        </inline-panel>
      </div>
    </td>
  </tr>
  </tbody>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/loan-transaction-history/loan-transaction-history.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;